export const colors = [
  '#FFB30F',
  '#008BF8',
  '#72E1D1',
  '#849324',
  '#FF92AE',
  '#F7936F',
  '#F16063',
  '#66CB9F',
  '#4C6FFF',
  '#FD151B',
];

/**
 * Net sentiment score palette, taken from the Figma source-profile design.
 * The chart tones fill the stacked bars, the legend dots and the trend line;
 * the gauge tones are the vivid ends of its gradient arc.
 */
export const sentimentColors = {
  positive: '#64C59B',
  neutral: '#9CAEBB',
  negative: '#EE6663',
  score: '#006C9C',
  gaugeStart: '#FF5630',
  gaugeMiddle: '#9CAEBB',
  gaugeEnd: '#36B37E',
  needle: '#C4C4C4',
  needlePivot: '#EDEDED',
  tick: '#777777',
};
